import {useMemo} from "react";

const useMonthLettersDateFormat = (dateString) => {
  const formatter = useMemo(
    () =>
      new Intl.DateTimeFormat("en-US", {
        day: "numeric",
        month: "short",
        year: "numeric"
      }),
    []
  );

  const dateParts = dateString.split("/");
  if (dateParts.length === 3) {
    const [day, month, year] = dateParts.map(Number);
    const parsedDate = new Date(year, month - 1, day);

    if (!isNaN(parsedDate.getTime())) {
      const formattedDate = formatter.format(parsedDate);

      const [monthDay, yearPart] = formattedDate.split(",");
      const [monthText, dayText] = monthDay.split(" ");

      return `${dayText} ${monthText},${yearPart}`;
    }
  }

  return null;
};

export default useMonthLettersDateFormat;
